import { createFileRoute } from "@tanstack/react-router"

import { StoredBuiltPalletsTab } from "@/screens/WarehouseReceiving/subfeatures/Stored/components/BuiltPalletsTab/StoredBuiltPalletsTab"

export const Route = createFileRoute("/app/warehouse-receiving/stored/$goodsReceiptId/_layout/built-pallets")({
  component: StoredBuiltPalletsTab,
})
